import type {Task} from '../universal/types'

export const getMilestoneProgress = <T extends Pick<Task, 'status'>>(tasks: T[]) => ({
    total: tasks.length,
    completed: tasks.filter((task) => task.status === 'COMPLETE').length,
})
